var React = require('react');

function Closex (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Close menu icon"),React.createElement("path",{"d":"M22.4 27.2l-12-12C8.8 13.6 6.7 11.9 9 9.5s4-.6 5.7 1.1l24.7 24.7c1.6 1.6 3.1 3.3 1.1 5.4-2.3 2.4-4 .6-5.7-1.1L22.4 27.2zm4.5.2l-12 12c-1.6 1.6-3.3 3.7-5.7 1.5s-.6-4 1.1-5.7L35 10.5c1.6-1.6 3.3-3.1 5.4-1.1 2.4 2.3.6 4-1.1 5.7L26.9 27.4z","key":1})]);
}

Closex.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = Closex;

Closex.default = Closex;
